import React from 'react'
import withIcon from '@/components/withIcon'

const IconArrowUpRight = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 4C6.5 3.72386 6.72386 3.5 7 3.5H12C12.2761 3.5 12.5 3.72386 12.5 4V9C12.5 9.27614 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.27614 11.5 9V4.5H7C6.72386 4.5 6.5 4.27614 6.5 4Z"
        fill="#162941"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3536 3.64645C12.5488 3.84171 12.5488 4.15829 12.3536 4.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L11.6464 3.64645C11.8417 3.45118 12.1583 3.45118 12.3536 3.64645Z"
        fill="#162941"
      />
    </svg>
  )
}

export default withIcon(IconArrowUpRight)
